import type { MenuItemTagV2 } from "@/models/menu-item-v2";
import { TAG_CODES } from "@/constants/tagRegistry";
import { hasTagCode } from "@/utils/tag-mapper";

/** Anything carrying catalog tags — legacy `MenuItemInterface`, V2 rows, UI models. */
type TaggedMenuItemLike = {
  tags?: MenuItemTagV2[] | null;
};

/**
 * Standalone-sale rule for a catalog menu item.
 *
 * `false` only when the item carries the `NOT_SOLD_INDIVIDUALLY` tag: the item
 * stays a normal Menu Item everywhere else (customization/modifier options,
 * combo components, cart lines, pricing) and is merely never offered as an
 * individually purchasable item on customer-facing catalog surfaces.
 *
 * Tag matching follows the existing {@link hasTagCode} convention — `tag_code`,
 * trimmed and case-insensitive.
 */
export function isIndividuallySellable(
  item: TaggedMenuItemLike | null | undefined
): boolean {
  return !hasTagCode(item?.tags ?? undefined, TAG_CODES.NOT_SOLD_INDIVIDUALLY);
}
